<template>
  <div v-if="visible" class="video-modal-overlay" @click.self="handleClose">
    <div class="video-modal-box">
      <div class="video-modal-hd">
        <h3>
          🎬 商品プロモーション動画
        </h3>
        <button class="video-modal-close" @click="handleClose">×</button>
      </div>

      <div class="video-modal-player">
        <div v-if="modalData.videoId" class="video-embed-wrap">
          <iframe
            v-if="iframeVisible"
            :src="embedUrl"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen
          ></iframe>
        </div>
        <div v-else class="video-no-content">
          <svg width="32" height="32" viewBox="0 0 10 10" opacity="0.4"><polygon points="2,1 9,5 2,9" fill="#fff"/></svg>
          <span>動画が登録されていません</span>
        </div>
      </div>

      <div class="video-modal-ft">
        <button class="video-btn-cancel" @click="handleClose">閉じる</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VideoPlayerModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    modalData: {
      type: Object,
      default: () => ({
        videoId: '',
        updateDate: ''
      })
    }
  },
  data () {
    return {
      iframeVisible: false
    }
  },
  computed: {
    embedUrl () {
      if (!this.modalData.videoId) return ''
      return `https://www.youtube.com/embed/${this.modalData.videoId}?autoplay=1&rel=0`
    }
  },
  watch: {
    visible (val) {
      if (val) {
        this.$nextTick(() => { this.iframeVisible = true })
      } else {
        this.iframeVisible = false
      }
    }
  },
  methods: {
    handleClose () {
      this.iframeVisible = false
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.video-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.55);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}
.video-modal-box {
  background: #111;
  border-radius: 8px;
  width: 660px;
  max-width: 95vw;
  box-shadow: 0 8px 32px rgba(0,0,0,0.5);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.video-modal-hd {
  background: #222;
  border-bottom: 1px solid #333;
  padding: 11px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
}
.video-modal-hd h3 {
  font-size: 13px;
  color: #fff;
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 0;
  font-weight: 700;
}
.video-modal-close {
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: #aaa;
  line-height: 1;
}
.video-modal-close:hover { color: #fff; }

.video-modal-player {
  background: #000;
  flex-shrink: 0;
}
.video-embed-wrap {
  position: relative;
  width: 100%;
  padding-bottom: 56.25%;
  height: 0;
}
.video-embed-wrap iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.video-no-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  height: 160px;
  color: #666;
  font-size: 13px;
}

.video-modal-ft {
  background: #222;
  border-top: 1px solid #333;
  padding: 10px 16px;
  display: flex;
  justify-content: flex-end;
  flex-shrink: 0;
}
.video-btn-cancel {
  font-size: 12px;
  color: #ccc;
  background: #333;
  border: 1px solid #555;
  padding: 5px 16px;
  border-radius: 4px;
  cursor: pointer;
}
.video-btn-cancel:hover { background: #444; color: #fff; }
</style>



// WEBPACK FOOTER //
// src/view/productsNew/VideoPlayerModal.vue